import { g as o } from "./index767.mjs";
import { e as t } from "./index865.mjs";
import { c as s } from "./index807.mjs";
var r = o, i = t, u = s, e = function(n) {
  return i.slice(0, n.length) === n;
}, l = function() {
  return e("Bun/") ? "BUN" : e("Cloudflare-Workers") ? "CLOUDFLARE" : e("Deno/") ? "DENO" : e("Node.js/") ? "NODE" : r.Bun && typeof Bun.version == "string" ? "BUN" : r.Deno && typeof Deno.version == "object" ? "DENO" : u(r.process) === "process" ? "NODE" : r.window && r.document ? "BROWSER" : "REST";
}();
export {
  l as e
};
